import React, { ReactNode } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { Box, Stack, Typography } from '@mui/material';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
/* === PromotionDisclaimer PROPS =============================================================== */
interface Props {
  children: ReactNode;
  product: 'ticket' | 'parking';
}

export const PromotionDisclaimer = ({ children, product }: Props) => {
  /* === STATES ======================================================================= */
  const { t } = useTranslation();

  /* === RENDER ======================================================================= */
  return (
    <Box mt={2} py={2} px={2} bgcolor={'#FFF8E1'} border={'1.5px solid rgb(207, 183, 30)'} borderRadius={2}>
      <Stack direction="row" gap="8px" mb={1.5}>
        <Stack direction="column" gap="12px">
          <LocalOfferIcon
            sx={{
              color: 'warning.main',
            }}
          />
        </Stack>
        <Typography color="primary" variant="body1" fontWeight={700}>
          {t(`bundle.${product}_promotion`)}
        </Typography>
      </Stack>
      <Typography variant="body2" color="secondary.light">
        {children}
      </Typography>
    </Box>
  );
};
